import { render } from "./DatatableSelect.vue?vue&type=template&id=6e5c772c"
import script from "./DatatableSelect.vue?vue&type=script&lang=js"
export * from "./DatatableSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Tables/DatatableSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e5c772c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e5c772c', __exports__)) {
    api.reload('6e5c772c', __exports__)
  }
  
  module.hot.accept("./DatatableSelect.vue?vue&type=template&id=6e5c772c", () => {
    api.rerender('6e5c772c', render)
  })

}


export default __exports__